import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import SearchIcon from '../../../common/components/SearchIcon';
import {withLoadedUser} from '../../../login/containers/AuthBase';
import CampaignDetailsModal from './CampaignDetailsModal';
import {Mutation} from 'react-apollo';
import ConfirmModal from '../../../common/components/ConfirmModal';
import {Button} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPencilAlt, faTimes} from '@fortawesome/free-solid-svg-icons';
import gql from 'graphql-tag';
import Error from '../../../common/components/Error/Error';
import {withTranslation} from 'react-i18next';
import FlexRow from '../../../common/components/layout/FlexRow';
import {CAMPAIGN_STATUS, COLORS} from '../../../common/constants';
import styled from 'styled-components';

const MargedDiv = styled.div`
  margin-left: 3px;
  margin-right: 3px;
`;

export const GRAPHQL_MUTATION_UPDATE_CAMPAIGN = gql`
  mutation updateCampaign($campaignInput: UpdateCampaignInput!) {
    updateCampaign(campaignInput: $campaignInput) {
      id
      status
    }
  }
`;

const displayError = t => () => <Error error={t('errorUpdating')}/>;

const CampaignRowAction = ({campaign, t}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const campaignInput = {
    cancel: true,
    id: campaign.id,
  };

  const canEditOrCancel = campaign.status === CAMPAIGN_STATUS.CREATED || campaign.status === CAMPAIGN_STATUS.STARTED;

  return (
    <FlexRow>
      <MargedDiv>
        {canEditOrCancel ? (
          <Button className="btn-update btn-update-disable" onClick={() => {
            setEditMode(true);
            setModalVisible(true);
          }}>
            <FontAwesomeIcon icon={faPencilAlt} color={COLORS.BLUE} size="sm"/>
          </Button>
        ) : (
          <SearchIcon onClick={() => {
            setEditMode(false);
            setModalVisible(true);
          }}/>
        )}
      </MargedDiv>
      <CampaignDetailsModal showModal={modalVisible} campaign={campaign} changeModalState={setModalVisible} editable={canEditOrCancel && editMode} />
      {canEditOrCancel && (
        <MargedDiv>
          <Mutation
            mutation={GRAPHQL_MUTATION_UPDATE_CAMPAIGN}
            variables={{campaignInput}}
            refetchQueries={['currentMerchant']}
            awaitRefetchQueries
          >
            {(mutation) => (
              <ConfirmModal
                title={t('cancelCampaign')}
                mutation={mutation}
                displayError={displayError(t)}
                size={'lg'}
                confirmBtn={'yes'}
                cancelBtn={'no'}
                extraContent={campaign.status === CAMPAIGN_STATUS.CREATED ? t('cancelCreatedCampaignText') : t('cancelStartedCampaignText')}
              >
                {askConfirmation => (
                  <div className="btn-disable">
                    <Button className="btn-update btn-update-disable" onClick={askConfirmation}>
                      <FontAwesomeIcon icon={faTimes} color={'red'} size="sm"/>
                    </Button>
                  </div>
                )}
              </ConfirmModal>
            )}
          </Mutation>
        </MargedDiv>
      )}

    </FlexRow>
  );
};

CampaignRowAction.propTypes = {
  t: PropTypes.func.isRequired,
  campaign: PropTypes.shape({
    id: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
  currentUser: PropTypes.object.isRequired,
};

export default compose(
  withLoadedUser,
  withTranslation('campaign'),
)(CampaignRowAction);
